import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ttxvdz3k8: FaireProductEntity = {
  token: "p_4ttxvdz3k8",
  type: "product",
  name: "16oz Raw Cinnamon Creamy Honey",
  brandToken: "b_2hhbtdht4d",
  brandName: "The Beekeeper's Daughter",
  imageUrl:
    "https://cdn.faire.com/fastly/7a3e17635fb24a18bfd9d57f58764b9024c4f770bbc27ef85dabc34532b661c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb848992eba95111464b77d43bbced0c3cdcb39eb18b49d42309c58cf302748a.jpeg",
    "https://cdn.faire.com/fastly/3c18e64254059b9e769960d7d2dbbaace71423cf0333b56d54f773c25f6a7043.jpeg",
    "https://cdn.faire.com/fastly/5c56ef18bfd12c26c0122a9e2b9b8d505ec85b767d89b9dff860f94aea823a0d.jpeg",
  ],
  priceDollars: 11.78,
  description:
    "Our Raw Creamy Cinnamon Honey is the perfect thick smooth texture for spreading on toast, bagels, smoothies, or simply melting in to tea. Handcrafted with wildflower honey and cinnamon added in. Our creamed honey also come in 3 other flavors - Blueberry, Wildflower, and Apricot.",
  tags: [],
  msrpDollars: 22.16,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:56.830Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
